import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import { Modal } from 'containers/misc'
import { Form } from 'components/layout'
import { Button } from 'components/misc'
import { Input, InputPassword } from 'components/fields'
import { form } from 'helpers/decorators'
import { changePasswordValidate } from 'models/persons'

const enhance = compose(
  form({
    form: 'change-person-password',
    validate: changePasswordValidate
  })
)

class ChangePassword extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    changePersonPassword: PropTypes.func.isRequired,
    personId: PropTypes.number,
    handleSubmit: PropTypes.func.isRequired,
    passwordSpecChars: PropTypes.string.isRequired
  }

  render() {
    const { handleSubmit, personId, passwordSpecChars } = this.props

    return (
      <div>
        <Button
          intlKey="button.change_password"
          type="button"
          onClick={() => this.props.modal('mdsads')}
        >
          Change password
        </Button>
        <Modal id="mdsads" customActions>
          <Form
            onSubmit={handleSubmit(fields =>
              this.props.changePersonPassword(personId, fields)
            )}
          >
            <div className="row">
              <div className="col-xs-6">
                <Input
                  name="currentPassword"
                  label="Current password"
                  intlKey="label.current_password"
                  type="password"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <InputPassword
                  name="newPassword"
                  label="New password"
                  intlKey="label.new_password"
                  type="password"
                  passwordSpecChars={passwordSpecChars}
                />
              </div>
              <div className="col-xs-6">
                <Input
                  name="newPasswordAgain"
                  label="Repeat new password"
                  intlKey="label.repeat_new_password"
                  type="password"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <Button
                  type="button"
                  secondary
                  onClick={() => this.props.modal(null)}
                >
                  <FormattedMessage id="button.close" defaultMessage="Close" />
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <Button>
                  <FormattedMessage
                    id="button.change"
                    defaultMessage="Change"
                  />
                </Button>
              </div>
            </div>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default enhance(ChangePassword)
